import { customElement } from 'lit/decorators.js'
import { Connection } from '@things-factory/integration-ui/dist-client'

@customElement('connection-list-page')
export class ConnectionListPage extends Connection {
  get context() {
    return {
      ...super.context,
      board_topmenu: true
    }
  }
}
